import { PawPrint } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const CHIPS = ["Pomsky", "Couleur fauve", "Né le 2 janvier 2026", "Médiateur en formation"];

export default function Bueno({ bg = "bg-linen" }) {
  return (
    <section className={`${bg} px-6 py-24 sm:px-10 md:py-32 lg:px-16`} data-testid="bueno-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal y={50}>
            <div className="relative">
              <div className="absolute -left-5 -top-5 h-full w-full blob-2 bg-sand/50" aria-hidden="true" />
              <div className="blob-2 relative aspect-[5/4] overflow-hidden shadow-[0_30px_60px_-30px_rgba(43,58,48,0.4)]">
                <img
                  src="/photos/bueno-portrait.webp"
                  alt="Bueno, pomsky fauve aux yeux bleus, en gros plan"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                  style={{ objectPosition: "55% 45%" }}
                  data-testid="bueno-image"
                />
              </div>
              <div className="absolute -bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2.5 whitespace-nowrap rounded-full border border-stone-border bg-cream/95 px-6 py-3 shadow-lg backdrop-blur-md" data-testid="bueno-caption">
                <PawPrint size={16} className="text-terracotta" />
                <span className="font-serif text-base italic text-ink">Grand médiateur auprès des enfants</span>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.1}>
            <p className="overline-label">Le médiateur de l'équipe</p>
            <h2 className="mt-4 font-serif text-3xl font-medium leading-[1.15] tracking-tight text-ink sm:text-4xl md:text-5xl">
              Bueno, <span className="italic text-terracotta">l'âme poilue de la méthode.</span>
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink/70 md:text-lg" data-testid="bueno-description">
              Pomsky couleur fauve né le 2 janvier 2026, Bueno se forme au rôle de
              chien médiateur. Et il a déjà un don : auprès des enfants, sa simple
              présence apaise, rassure et ouvre le dialogue là où les mots bloquent.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {CHIPS.map((chip, i) => (
                <span
                  key={chip}
                  className="rounded-full border border-terracotta/25 bg-terracotta/5 px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-terracotta-deep transition-transform duration-300 hover:-translate-y-0.5"
                  data-testid={`bueno-chip-${i + 1}`}
                >
                  {chip}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
